import React from 'react';
import { _dict, _faqData, _helpCards } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';

import './HelpPage.css'; // Import a CSS file for styling
import { IonIcon } from '@ionic/react';
import { logoFacebook, logoTiktok, logoTwitter, logoYoutube } from 'ionicons/icons';
import FaqList from './FaqItem';
import FeedbackComponent from './FeedbackComponent';
import VideoTutorialsSection from './VideoTutorialsSection';

interface HelpPageProps {
    
}

const HelpPage: React.FC<HelpPageProps> = (props) => {
    const { lang } = useGlobalStore();
    


    const links = [
        { icon: logoFacebook, title: "Facebook", url: "https://www.facebook.com/dsapp.comunicare" },
        { icon: logoYoutube, title: "YouTube", url: "https://www.youtube.com/@ClipTalkApp" },
        { icon: logoTwitter, title: "Twitter (X)", url: "https://twitter.com/cliptalk_app" },
        { icon: logoTiktok, title: "TikTok", url: "https://www.tiktok.com/@cliptalk.app?_t=8iGJizAQiW1&_r=1" }
    ];

    return (
        <div className="help-page-container">
            <FeedbackComponent />
            <VideoTutorialsSection />

            <div className="links-section">
                <h1 className="section-heading">{_dict["askOnOfficialPages"][lang]}</h1>
                <div className="links-grid">
                    {links.map((link, index) => (
                        <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="link-card">
                            <IonIcon icon={link.icon} className="link-icon" />
                            {link.title}
                        </a>
                    ))}
                </div>
            </div>

            {_faqData.length > 0 && <><h1 className="section-title">{_dict["frequentlyAskedQuestions"][lang]}</h1>
            <div className="faq-container">
                <FaqList faqData={_faqData} lang={lang} />
            </div></>}

            
        </div>
    );
};

export default HelpPage;
